import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestCookieUnassignedGet = {
    path: "/cookies/unassigned",
    method: RouteHttpVerb.GET
};
export { locationRestCookieUnassignedGet };
